/** An empty list says why it is empty and what would fill it. `all-clear` is the good kind: nothing needs you. */
import type { ReactNode } from 'react'
import { Light } from '../primitives/Light'
import s from './States.module.css'

export function EmptyState({ kind = 'nothing', title, children, action }: { kind?: 'all-clear' | 'nothing' | 'filtered'; title: string; /** Why, and what fills it. */ children?: ReactNode; action?: ReactNode }) {
  return (
    <div className={s.empty}>
      {kind === 'all-clear' && <Light state="ok" size="lg" word="all clear" />}
      <b className={s.emptyTitle}>{title}</b>
      {children && <p className={s.emptyBody}>{children}</p>}
      {action}
    </div>
  )
}
